import { render, staticRenderFns } from "./IndoorSetting.vue?vue&type=template&id=6651826e&scoped=true&"
import script from "./IndoorSetting.vue?vue&type=script&lang=js&"
export * from "./IndoorSetting.vue?vue&type=script&lang=js&"
import style0 from "./IndoorSetting.vue?vue&type=style&index=0&id=6651826e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6651826e",
  null
  
)

export default component.exports